'use strict';

const $ = jQuery.noConflict();

class VPC {

  debug = false;

  constructor() {

    document.body.addEventListener('click', (event) => {
      let targetElement = event.target;

      while (targetElement != null) {
        if (targetElement.classList.contains('js-vpc-btn-add-favorite')) {
          event.preventDefault();
          const postId = parseInt(targetElement.getAttribute('data-post-id'));
          const remFavTitle = targetElement.getAttribute('data-rem-title');
          const addFavTitle = targetElement.getAttribute('data-add-title');

          targetElement.classList.add('disabled');
          targetElement.classList.toggle('is-active');

          const data = new FormData();
          data.append('action', 'viepico_toggle_favorite_posts');
          data.append('postid', postId);
          data.append('nonce', viepico_scripts_params.nonce);

          const isFavoritePost = targetElement.classList.contains('is-active') ? 'yes' : 'no';
          data.append('is_favorite', isFavoritePost);

          targetElement.setAttribute('title', isFavoritePost === 'yes' ? remFavTitle : addFavTitle);

          fetch(viepico_scripts_params.ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: data
          }).then((response) => response.json()).then((data) => {
            if(this.debug) console.log(data);

            targetElement.classList.remove('disabled');
          }).catch((error) => {
            if(this.debug) console.error(error);

            targetElement.classList.remove('disabled');
          }).finally(() => {
            targetElement.classList.remove('disabled');
          });

          return;
        }
        targetElement = targetElement.parentElement;
      }
    });

    if (this.isUbicacionesSinglePost() && this.isPostHasRating()) {
      vpcRatyInit();
      this.ratyElementsInit();
      this.ratyHandlers();
    }
  }

  isUbicacionesSinglePost() {
    return document.body.classList.contains('viepico-single-ubicaciones');
  }

  isPostHasRating() {
    return document.getElementsByClassName('js-vpc-rating').length > 0;
  }

  ratyElementsInit() {
    this.$raty = $('.js-vpc-rating');
    this.$ratyCounter = document.getElementById('js-vpc-rate-counter');
    this.$userScore = document.getElementById('js-vpc-user-score');
    this.$ratyTarget = document.getElementById('target-rating');
    this.$ratingBlock = document.getElementById('js-vpc-rating-block');
    this.$activeRating = document.getElementById('js-vpc-active-rating');
    this.$submitRating = document.getElementById('js-vpc-submit-rating');
    this.$cancelRating = document.getElementById('js-vpc-cancel-rating');
    this.$reActiveRating = document.getElementById('js-vpc-re-active-rating');
  }

  ratyHandlers() {
    this.$activeRating.addEventListener('click', (e) => {
      e.preventDefault();

      this.$activeRating.classList.add('hide');

      this.$submitRating.classList.remove('hide');
      this.$cancelRating.classList.remove('hide');

      this.readonlyRating(false);
      this.resetRating();

    });

    this.$reActiveRating.addEventListener('click', (e) => {
      e.preventDefault();

      this.$reActiveRating.classList.add('hide');

      this.$submitRating.classList.remove('hide');
      this.$cancelRating.classList.remove('hide');

      this.readonlyRating(false);
      this.resetRating();

    });

    this.$cancelRating.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.$ratingBlock.classList.contains('vpc-rating-block--rated')) {
        this.$reActiveRating.classList.remove('hide');
      } else {
        this.$activeRating.classList.remove('hide');
      }

      this.$submitRating.classList.add('hide');
      this.$cancelRating.classList.add('hide');

      this.restoreRating();
      this.readonlyRating(true);
    });

    this.$submitRating.addEventListener('click', (e) => {
      e.preventDefault();

      this.$ratingBlock.classList.add('loading');

      const data = new FormData();
      data.append('action', 'viepico_set_posts_rating');
      data.append('postid', parseInt(this.$ratyTarget.getAttribute('data-post-id')));
      data.append('score', parseInt(this.$ratyTarget.value));
      data.append('nonce', viepico_scripts_params.nonce);

      fetch(viepico_scripts_params.ajax_url, {
        method: 'POST',
        credentials: 'same-origin',
        body: data
      }).then((response) => response.json()).then((data) => {
        if(this.debug) console.log(data);

        this.$submitRating.classList.add('hide');
        this.$cancelRating.classList.add('hide');

        this.$reActiveRating.classList.remove('hide');

        this.$ratyCounter.textContent = parseInt(data.totalRatings);

        this.$userScore.textContent = parseInt(data.currentScore);

        this.setRatingScore(parseInt(data.totalScore));
        this.readonlyRating(true);

        this.$ratingBlock.classList.remove('loading');
      }).catch((error) => {
        if(this.debug) console.error(error);

        this.$ratingBlock.classList.remove('loading');
      }).finally(() => {
        this.$ratingBlock.classList.remove('loading');
      });

    });
  }

  setRatingScore(score) {
    this.$raty.data('raty').move(score);
    this.$raty.data('raty').score(score);

    this.$ratyTarget.value = score;
  }

  restoreRating() {
    const score = this.$raty.data('score');

    this.$raty.data('raty').move(score);
    this.$raty.data('raty').score(score);

    this.$ratyTarget.value = score;
  }

  resetRating() {
    this.$raty.data('raty').cancel(true);
    this.$raty.data('raty').move(0);
    this.$raty.data('raty').score(0);
    this.$ratyTarget.value = '';
  }

  readonlyRating(flag) {
    this.$raty.data('raty').readOnly(flag);
  }
}

(function($) {
  $(function() {
    new VPC();
  });
})($);
